var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ProfileHeader'),_vm._v(" "),_c('router-view',{staticStyle:{"overflow-y":"scroll"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }